export const project1 = {
  id: 'business-development-manager',
  name: 'Business Development Manager',
  description: `
      <p>
        Do nášho obchodného tímu hľadáme skúseného obchodníka/ obchodníčku, ktorý/ározumie fungovaniu IT trhu, vie
        identifikovať obchodné príležitosti a nebojí sa aktívnejakvizície. Ideálne niekoho, kto už má skúsenosť s
        predajom IT služieb a riešení a dokáževiesť obchodné rokovania na úrovni.
      </p>

      <p class="tw-heading-5"><strong>Čo bude tvojou hlavnou úlohou?</strong></p>

      <ul>
        <li>
          Aktívne vyhľadávať a získavať nových firemných klientov v oblasti IT outsourcingu.
        </li>
        <li>
          Viesť obchodné stretnutia, prezentovať naše služby a riešenia, a hľadať novéobchodné príležitosti na mieru potrebám zákazníka.
        </li>
        <li>
          Vyjednávať obchodné podmienky v súlade s našou cenovou politikou a firemnoustratégiou.
        </li>
        <li>
          Budovať a udržiavať dlhodobé vzťahy s existujúcimi klientmi a zmluvnýmipartnermi.
        </li>
        <li>
          Úzko spolupracovať s ostatnými členmi tímu a prispievať k spoločným cieľom.
        </li>
      </ul>

      <p class="tw-heading-5"><strong>Čo od teba očakávame?</strong></p>
      <ul>
        <li>Prax v obchode, ideálne v oblasti IT alebo technológií.</li>
        <li>Schopnosť samostatne vyhľadávať a osloviť nové firmy.</li>
        <li>Vynikajúce komunikačné a vyjednávacie schopnosti.</li>
        <li>Príjemné, profesionálne a reprezentatívne vystupovanie.</li>
        <li>Orientácia na výsledok, nadšenie pre obchod a networking.</li>
        <li>Prehľad v oblasti IT služieb výhodou.</li>
        <li>Nemčina (min. C1) alebo angličtina na komunikačnej úrovni min. B2.</li>
        <li>Vodičský preukaz B.</li>
      </ul>

      <p class="tw-heading-5"><strong>Čo ti ponúkame?</strong></p>
      <ul>
        <li>Motivačný systém odmien</li>
        <li>Príležitosť ovplyvniť obchodnú stratégiu a rásť spolu s firmou.</li>
        <li>Možnosť kariérneho rastu</li>
        <li>Podpora vo vzdelávaní a osobnostnom raste</li>
        <li>Kvalitný produkt a skúsený tím, ktorý ti kryje chrbát.</li>
        <li>Práca v úspešnej spoločnosti a v priateľskom kolektíve.</li>
        <li>MultiSport karta</li>
      </ul>

      <p>
        Ak ťa baví komunikácia s ľuďmi a máš nadšenie pre IT, neváhaj nám poslať svoj životopis.Ak vieš predať nielen
        služby, ale aj sám seba tešíme sa na tvoj krátky motivačný list. Akpresvedčíš, pozvanie na pohovor máš isté.
        Vopred ďakujeme všetkým kandidátom, ktorívedia zaujať.
      </p>

      <p><strong>Odmena</strong></p>
      <p>
        Pri nástupe: 2300 EUR/ mesiac<br />
        Po skúšobnej dobe: 2 500 EUR/ mesiac<br />
        + zaujímavý odmeňovací systém v závislosti od výkonu
      </p>

      <p>
        Sme softvérová spoločnosť, ktorá okrem vývoja softvéru poskytuje aj špičkové služby voblasti <b>IT outsourcingu</b>.
        Našou misiou je <b>prepájať skúsených IT špecialistov s týmisprávnymi projektmi – rýchlo, efektívne a s dôrazom
        na kvalitu</b>.
      </p>
  `,
  language: 'Nemčina / Angličtina',
  city: 'Bratislava',
  partner: null,
  profession: null,
  requiredLevels: [],
  states: [
    {
      value: 'PUBLISHED',
      displayString: 'Published',
    },
  ],
  expertises: [],
  tags: [],
  legalRelationType: { value: 'CONTRACTOR' },
  remoteOfficePercentage: null,
  hourlyRate: null,
  mdBudgetFrom: null,
  mdBudgetTo: null,
  monthlySalaryFrom: null,
  monthlySalaryTo: null,
  publishedAt: '2025-06-11',
  jobStartDate: '2025-07-01',
  projectLengthInMonths: null,
  responsibleHR: {
    name: 'Kristína Petreková',
    email: 'petrekova@objectify.sk',
  },
}

export const careerProjects = [project1]
